import React from "react";

import { DashboardPageTemplate } from "../../Utils/DashboardPageTemplate";

export const OverviewDashboard = () => {
  return <DashboardPageTemplate pageName={"overview"} showCogsWarning={true} />;
};
